import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import * as CompareStyles from "./CompareStyles";
import * as Button from "../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as Toggle from "../../../../../common-deprecated/styles/v2/lexus/components/Toggle";
import * as TextStyles from "../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import Text from "../../../../../common-deprecated/styles/lexus/Text";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled(CompareStyles.Row)<SpaceProps>`
    flex-direction: column;
    ${space};
`;

export const Header = styled.header`
    margin-top: 32px;

    ${Toggle.Wrapper} {
        width: 100%;
        @media ${getBreakpoint("up", "md")} {
            width: auto;
        }
    }

    ${Button.ButtonWithIcon} {
        ${TextStyles.IconButton} {
            margin-left: 0;
            padding-left: 0;
        }
    }

    html[dir="rtl"] & {
        ${Button.ButtonWithIcon} {
            ${TextStyles.IconButton} {
                margin-right: 0;
                padding-right: 0;
            }
        }
    }
`;

export const Title = styled.h2.attrs(() => ({
    className: "l-gamma-text",
}))`
    font-family: ${theme.fonts.regular};
    font-size: 2.8rem;
    letter-spacing: 0.2rem;
    line-height: 3.6rem;
    text-align: start;
    text-transform: uppercase;
    @media ${getBreakpoint("up", "md")} {
        font-size: 4rem;
        line-height: 5rem;
    }
`;

export const Description = styled.div<{ isPdf?: boolean } & SpaceProps>`
    position: relative;
    font-size: 1.8rem;
    ${space};

    @media ${getBreakpoint("up", "md")} {
        display: ${({ isPdf }) => (isPdf ? "block" : "flex")};
        align-items: center;
        justify-content: space-between;
        text-align: start;
    }

    ${Text} {
        position: relative;
        flex-shrink: 1;
        margin-bottom: 20px;
        @media ${getBreakpoint("up", "md")} {
            margin-bottom: 0;
        }

        svg {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -40px;
            margin-right: 6px;
        }
    }

    html[dir="rtl"] & {
        ${Text} {
            svg {
                left: auto;
                right: 0;
                margin-left: 6px;
                margin-right: 0;
            }
        }
    }
`;
